jQuery(document).ready(function($) {
    let currentStep = 1;
    let steps = 6;
    let form = $('.custom-design-now-form');
    let date = (new Date(Date.now())).toString();
    if(document.getElementById('started_at')){
        document.getElementById('started_at').value = date;
    }
  
    let textFields = ['name', 'sorority_custom', 'university_custom', 'more_details']
    textFields.forEach(function(field) {
        $('.custom-design-now-form input[name="'+ field +'"], .custom-design-now-form textarea[name="'+ field +'"]').on('input', function(event) {
          $(this).val(event.target.value.replace(/[\u{0080}-\u{FFFF}]/gu, ""))
        })
    })

    setTimeout(function(){
        setAttributesFromParams();
    }, 1500);   

    String.prototype.hashCode = function() {
        let hash = 0,
            i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    }

    function setAttributesFromParams(){
        const urlParams = new URLSearchParams(window.location.search);

        $('input[type="radio"][name="what_is_it_for"]').change();

        const source_image_url = urlParams.get('source_image_url');
        if(source_image_url != "" && source_image_url != null && source_image_url != undefined){
          $(".custom_form_layout__image img").attr("src", source_image_url);
          $(".mobile_img_preview .mobile_img_preview__img").css("background-image", "url(" + source_image_url + ")");
        }        

        const source_url = urlParams.get('source_url');
        if(source_url != "" && source_url != null && source_url != undefined){
            $(".radio_btns_wrap #product_url").val(source_url);
        }        
    }

    function disabledNextForCurrent(){
        form.find('.multistep-step__' + currentStep).find('.custom_next').attr('disabled', true);
    }

    function enableNextForCurrent(){
        form.find('.multistep-step__' + currentStep).find('.custom_next').removeAttr('disabled');
    }

    function validatePhoneNumber(input_str) {
        var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

        return re.test(input_str);
    }
    function validatePhoneKeyPress(evt) {
        var theEvent = evt || window.event;

        if (theEvent.type === 'paste') {
            key = event.clipboardData.getData('text/plain');
        } else {
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /^\d+$/;
        if( !regex.test(key) ) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    function goToNext(){
        if(currentStep <= steps) {
            form.find('.multistep-step__' + currentStep++).removeClass('current');
            form.find('.multistep-step__' + currentStep).addClass('current');
        }
        if(currentStep === 2){
            $('.custom-design-now-form input[name="name"]').on('input', function(event) {
                if(event.target.checkValidity()){
                    enableNextForCurrent();
                } else {
                    disabledNextForCurrent();
                }
            });
        }
        /*if(currentStep === 5) {
            $('.custom-design-now-form #sorority').on('change', function(){
                if($(this).val() || $('.custom-design-now-form input[name="sorority_custom"]').val()){
                    enableNextForCurrent();
                } else {
                    disabledNextForCurrent();
                }
            })
            $('.custom-design-now-form input[name="sorority_custom"]').on('input', function(event) {
                if($(this).val() || $('.custom-design-now-form #sorority').val()){
                    enableNextForCurrent();
                } else {
                    disabledNextForCurrent();
                }
            });
        }*/

        if(currentStep === 3){
            $('.custom-design-now-form input[name="email"]').on('input', function(event) {
                var email = $(this).val();
                if( event.target.checkValidity() && 
                    $('.custom-design-now-form input[name="phone"]')[0].checkValidity() && 
                    email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) != null){
                    enableNextForCurrent();
                } else {
                    disabledNextForCurrent();
                }
            });
            $('.custom-design-now-form input[name="phone"]').keypress(function(event){
                validatePhoneKeyPress(event);
            });

            $('.custom-design-now-form input[name="phone"]').keypress(function(event) {
                var key = event.keyCode || event.charCode;
                if( key != 8 && key != 46 ){
                    if(event.target.value.length === 1 && /^\d+$/.test(event.target.value)) {
                        $('.custom-design-now-form input[name="phone"]').val('('+event.target.value);
                    }

                    if(event.target.value.length === 4) {
                        $('.custom-design-now-form input[name="phone"]').val(event.target.value+')-');
                    }

                    if(event.target.value.length === 9) {
                        $('.custom-design-now-form input[name="phone"]').val(event.target.value +"-");
                    }

                }
            })
            $('.custom-design-now-form input[name="phone"]').on('input', function(event) {
                var email = $('.custom-design-now-form input[name="email"]')[0];
                email = email.val();
                if( validatePhoneNumber(event.target.value) && 
                    $('.custom-design-now-form input[name="email"]')[0].checkValidity() && 
                    email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) != null){
                    enableNextForCurrent();
                } else {
                    disabledNextForCurrent();
                }
            });
        }
    }
    
    function goToPrev(){
        if(currentStep-1 > 0){
            form.find('.multistep-step__' + currentStep--).removeClass('current');
            form.find('.multistep-step__' + currentStep).addClass('current');
        }
    }

    function updateLoaderWidth(currentStep) {
        let width = Math.round((currentStep * 100) / steps);
        $('.form_loader').css('width', width + '%')
    }

    if($('#session_id').val() === '') {
        let hash = 2081383921;
        if(window.sessionStorage.amEventSid != null){
            hash = (window.sessionStorage.amEventSid + Date.now()).hashCode();
        }        
        $('#session_id').val(hash);
        Cookies.set('session_id', hash);
    }

    $('input[data-show-on-check]').each(function(){
        let name = $(this).attr('name');
        let value = $(this).val();
        let target = $(this).data('show-on-check');
        $('input[name="'+name+'"').on('change', function(){
            if(value === $(this).val()){
                $('#'+target).show();
            } else {
                $('#'+target).hide();
            }
        })
    })

    $('input[type="radio"][name="what_is_it_for"]').on('change', function() {
        let img_src = $('#just_for_fun_img').attr('src');
        if(this.value === 'Just for fun') {
            $('#for_an_event_img').hide();
            $('#just_for_fun_img').show();
            $('.mobile_img_preview__img').css('background-image', `url(${img_src})`);
        } else if(this.value === 'For an event') {
            $('#just_for_fun_img').hide();
            $('#for_an_event_img').show();
            $('.mobile_img_preview__img').css('background-image', `url(${img_src})`);
        }
    });

    $('.custom_next').on('click', function() {
        let formData = new FormData(document.getElementById('design-now-form'));
        let email = $('.multistep-body input[name="email"]').val();

        if(typeof email !== 'undefined' && 
           email !== '' && 
           email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) != null) {
            Cookies.set('design-customer-email', email)
        }

        let name = $('.multistep-body input[name="name"]').val();
        if(typeof name !== 'undefined' && name !== '') {
            Cookies.set('design-customer-name', name)
        }
        setTimeout(function() {
            if(typeof email !== 'undefined' && email !== '') {
                $.ajax({
                    url: $('#design-now-form').data('zapier-step-action'),
                    data: formData,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                });
            }            

            goToNext();
            updateLoaderWidth(currentStep);
            let name = $('.multistep-body input[name="name"]').val();
            if(name) {
                $('.hi_name').text(name)
            }
            $([document.documentElement, document.body]).animate({
                scrollTop: 0
            }, 50);
        }, 100);
    });

    $('.custom_next--button-skip').on('click', function() {
        let step = $(this).data('step');
        if(step) {
            element = $('.multistep-step__' + step);
            element.find('input:text').val('');
            element.find('select').val('').trigger('change');
            element.find('input[type="checkbox"]').prop('checked', false);
            element.find('input[type="radio"]').prop('checked', false);
        }
        setTimeout(function() {
            goToNext();
        }, 100);
    });

    $('.custom_prev_btn').on('click', function(e){
        e.preventDefault();
        goToPrev();
        updateLoaderWidth(currentStep);
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 50);
    });

    $('#design-now-form').on('submit', function(e) {
        $('#submit-button').prop('disabled', true);
        let date = (new Date(Date.now())).toString();
        e.preventDefault();
        let formData = new FormData(document.getElementById('design-now-form'));
        formData.set('submitted_at', date);
        $.ajax({
            url: $('#design-now-form').data('zapier-step-action'),
            data: formData,
            processData: false,
            contentType: false,
            type: 'POST',
        });
        $.ajax({
            url: $('#design-now-form').data('zapier-action'),
            data: formData,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function(data){
                window.location = $('#design-now-form').data('redirect')
            }
        });
    });

    $('.js-repeater-group').each(function(){
        limit = $(this).data('max-repeats');
        repeats = 1;

        addButton = $(this).find('button.add-button');
        removeButton = $(this).find('button.remove-button');

        target = $(this).find('.js-repeater-target');
        target = target.clone();
        target.removeClass('js-repeater-target');
        target.find('input').val('');
        container = $(this).find('.js-repeats-container');

        addButton.on('click', function(e){
            e.preventDefault();
            removeButton.show();
            clone = target.clone();
            newName = clone.find('input').attr('name').replace('1', ++repeats);
            clone.find('input').attr('name', newName);
            container.append(clone);
            if(repeats + 1 > limit) addButton.hide();
        })
        removeButton.on('click', function(e){
            e.preventDefault();
            if(--repeats < 2) removeButton.hide();
            addButton.show();
            container.children().last().remove();
        })
    })

    $('.view_design').on('click', function(e) {
        e.preventDefault();
        $('#image_preview_modal').addClass('open');
        $('html').addClass('noscroll')
    });

    $('.image_preview_modal__close').on('click', function(e) {
        e.preventDefault();
        $('#image_preview_modal').removeClass('open');
        $('html').removeClass('noscroll')
    });

    $('.click_open').on('click', function(e) {
        e.preventDefault();
        $(this).parent().parent().find('input[type="text"]').prop("disabled", false);
        $(this).parent().parent().find('input[type="text"]').show();
        if($(this).hasClass('click_open--univ')) {
            $(this).parent().parent().parent().find('#university').val('').trigger('change');
        } else if($(this).hasClass('click_open--sor')) {
            $(this).parent().parent().parent().find('#sorority').val('').trigger('change');
        }
    });


    /*if(typeof window.custom_form_settings.sororities_url !== 'undefined' && window.custom_form_settings.sororities_url) {
        $.ajax({
            // url: 'https://2i71en4saqnnccdt-42530177183.shopifypreview.com/pages?preview_key=deb29b6198c308563a6563c1e2c79545&view=sororities',
            url: window.custom_form_settings.sororities_url,
        }).done(function( data ) {
            let response = $.parseJSON(data);
            if(typeof response.results !== 'undefined') {
                $('#sorority').select2({
                    data: response.results,
                    placeholder: "Type to search",
                    tags: false
                });
            }
        });
    }

    if(typeof window.custom_form_settings.universities_url !== 'undefined' && window.custom_form_settings.universities_url)  {
        $.ajax({
            // url: 'https://2i71en4saqnnccdt-42530177183.shopifypreview.com//pages?preview_key=8808bf55a8160dae8237ba902643355c&view=universities',
            url: window.custom_form_settings.universities_url,
        }).done(function( data ) {
            let response = $.parseJSON(data);
            if(typeof response.results !== 'undefined') {
                $('#university').select2({
                    data: response.results,
                    placeholder: "Type to search",
                    tags: false
                });
            }
        });
    }*/

    $( "#datepicker" ).datepicker({
        minDate:  (new Date()),
        // changeMonth: true,
        autoSize: false,
        beforeShow: function(input, inst) {
            setTimeout(function() {
                inst.dpDiv.outerWidth(input.offsetWidth);
            }, 0);
        },

        onUpdateDatepicker: function(inst) {
            inst.dpDiv.outerWidth(this.offsetWidth);
        }
    });


    $(window).keydown(function(event){
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    $(".radio_btn__action .radio_btn").click(function(e){
        e.preventDefault();
        $(".custom_next.pos_next").addClass("hide");
        $("#what_is_your_position_other").addClass("hide");
        $(this).find("input[type=radio]").prop("checked", "checked");
        if(!$(this).hasClass("other")){
            $('.custom_next.pos_next').click();
        }else{
            $("#what_is_your_position_other").removeClass("hide");
            $(".custom_next.pos_next").removeClass("hide");
        }     
    });
    $("body").on("click", ".custom_next--button.upload", function(e){
        e.preventDefault();
        $(this).parent().find("input[type=file]").click();
    });
});
